import { Link } from "react-router-dom";

const linkConfigurations = [
    {
        path: '/',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/hari-pelaksanaan',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/hari-pelaksanaan/hari-penetasan',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/hari-pelaksanaan/pembentukan-hari-1',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/hari-pelaksanaan/pembentukan-hari-2',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/hari-pelaksanaan/kuliah-perdana',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/dibalik-kepanitiaan',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/sayembara-visual',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/after-movie',
        element: (
            <div className="nav-link">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/divisi',
        element: (
            <div className="nav-link active">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="default-bullet"></div>
        ),
        style: { background: 'var(--default-button)' }
    },
    {
        path: '/divisi-bimantara',
        element: (
            <div className="nav-link active bimantara">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="bimantara-bullet"></div>
        ),
        style: { background: 'var(--bimantara-button)' }
    },
    {
        path: '/divisi-kampana',
        element: (
            <div className="nav-link active kampana">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="kampana-bullet"></div>
        ),
        style: { background: 'var(--kampana-button)' }
    },
    {
        path: '/divisi-arsa',
        element: (
            <div className="nav-link active arsa">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="arsa-bullet"></div>
        ),
        style: { background: 'var(--arsa-button)' }
    },
    {
        path: '/divisi-adhyasta',
        element: (
            <div className="nav-link active adhyasta">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="adhyasta-bullet"></div>
        ),
        style: { background: 'var(--adhyasta-button)' }
    },
    {
        path: '/divisi-syandana',
        element: (
            <div className="nav-link active syandana">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="syandana-bullet"></div>
        ),
        style: { background: 'var(--syandana-button)' }
    },
    {
        path: '/divisi-sambara',
        element: (
            <div className="nav-link active sambara">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="sambara-bullet"></div>
        ),
        style: { background: 'var(--sambara-button)' }
    },
    {
        path: '/divisi-dayaka',
        element: (
            <div className="nav-link active dayaka">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="dayaka-bullet"></div>
        ),
        style: { background: 'var(--dayaka-button)' }
    },
    {
        path: '/divisi-sarwaga',
        element: (
            <div className="nav-link active sarwaga">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="sarwaga-bullet"></div>
        ),
        style: { background: 'var(--sarwaga-button)' }
    },
    {
        path: '/divisi-prabangkara',
        element: (
            <div className="nav-link active prabangkara">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="prabangkara-bullet"></div>
        ),
        style: { background: 'var(--prabangkara-button)' }
    },
    {
        path: '/divisi-wiskira',
        element: (
            <div className="nav-link active wiskira">
                <Link to="/divisi">Foto Divisi</Link>
            </div>
        ),
        bullet: (
            <div className="wiskira-bullet"></div>
        ),
        style: { background: 'var(--wiskira-button)' }
    },
];

export default linkConfigurations;